// extracted by mini-css-extract-plugin
module.exports = {"label":"block_label__Ns1sC","list":"block_list__6YoTr","item":"block_item__u4Qfu","heading":"block_heading__mOzjZ","content":"block_content__65EID"};